const Documentacao = [
  {
    id: 1,
    name: 'dnit',
    label: 'Dnit',
  },
  {
    id: 2,
    name: 'cnh',
    label: 'Carteira Nacional de Habilitação (CNH)',
  },
];

const Motorista = [
  { id: 3, name: 'epis', label: 'EPIs' },
  {
    id: 4,
    name: 'roupasApropriadas',
    label:
      'Motorista com roupas apropriadas ? Camisa com manga, calcado fechado, calca comprida',
  },
  {
    id: 5,
    name: 'acompanhantes',
    label: 'Ha acompanhantes com o motorista?',
  },
  {
    id: 6,
    name: 'alertaVazamentos',
    label:
      'Motorista esta alertado sobre nao fazer uso de qualquer liquido, para vedar vazamentos na cacamba ou carroceria?',
  },
  {
    id: 7,
    name: 'alertaAlimentacao',
    label:
      'Motorista esta alertado sobre nao se alimentar no setor de armazenagem?',
  },
  {
    id: 8,
    name: 'alertaSomAlto',
    label:
      'Motorista alertado que e proibido o uso de som alto dentro das dependencias da usina?',
  },
];

const Veiculo = [
  {
    id: 9,
    name: 'paraChoques',
    label: 'Para-choques danificados',
  },
  {
    id: 10,
    name: 'placasDanificadas',
    label: 'Placas danificadas',
  },
  {
    id: 11,
    name: 'faroisDanificados',
    label: 'Farois danificados',
  },
  {
    id: 12,
    name: 'lanternasSetasDanificadas',
    label: 'Laterna/Setas danificadas',
  },
  {
    id: 13,
    name: 'extintorIncendio',
    label: 'Extintor de incendio',
  },

  {
    id: 14,
    name: 'vazamentoCombustivel',
    label: 'Vazamento de combustivel',
  },

  {
    id: 15,
    label: 'Fitas refletivas',
    name: 'fitasRefletivas',
  },

  { id: 16, name: 'pneusBomEstado', label: 'Pneus em bom estado' },

  { id: 17, name: 'galoes', label: 'Galoes' },
];

const CacambaCarroceria = [
  {
    id: 18,
    name: 'buracos',
    label: 'Buracos',
  },
  {
    id: 19,
    name: 'odorEstranho',
    label: 'Odor estranho',
  },
  { id: 20, name: 'presencaPragas', label: 'Presenca de pragas' },
  { id: 21, name: 'residuoCarga', label: 'Residuo de carga' },
  { id: 22, name: 'umidade', label: 'Umidade' },
  { id: 23, name: 'limpo', label: 'Limpo' },
];

const Lona = [
  {
    id: 24,
    name: 'lonaComResiduos',
    label: 'Com residuos',
  },
  { id: 25, name: 'lonaDanificada', label: 'Danificada' },
  {
    id: 26,
    name: 'lonaLimpa',
    label: 'Limpa',
  },
  {
    id: 27,
    name: 'lonaSeca',
    label: 'Seca',
  },
  {
    id: 28,
    name: 'lonaOdorEstranho',
    label: 'Odor estranho',
  },
  {
    id: 29,
    name: 'lonaPresencaPragas',
    label: 'Presenca de pragas',
  },
  {
    id: 30,
    name: 'lonaResiduoCarga',
    label: 'Residuo de carga',
  },
];

const Outros = [
  {
    id: 40,
    name: 'responsavel',
    label: 'Responsável pela Inspeção',
  },
  {
    id: 41,
    name: 'horarioInspecao',
    label: 'Horário da Inspeção',
  },
];

export const ChecklistDataVhp = {
  Documentacao,
  Motorista,
  Veiculo,
  CacambaCarroceria,
  Lona,
  Outros,
};
